
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Row } from '@warrenbrasil/nebraska-web';
import { GlobalTransactionAmount } from '@/modules/transaction/components/GlobalTransactionAmount';
import { GlobalTransactionStatus } from '@/modules/transaction/components/GlobalTransactionStatus';
import { TransactionTransfer } from '../TransactionTransfer';
import { TransactionRow } from '../../types';
import { Money } from '@/modules/common/components/Money';

@Component({
  components: {
    Row,
    GlobalTransactionAmount,
    GlobalTransactionStatus,
    TransactionTransfer,
    Money
  }
})
export default class TransactionsTableMobile extends Vue {
  @Prop({ type: Array, default: [] })
  private transactions!: TransactionRow[];

  @Prop({ type: Boolean, default: false })
  private canHideMoneyVisibility!: boolean;

  @Emit()
  private clickTransaction(transaction: TransactionRow) {
    return transaction;
  }
}
